module.exports = __webpack_public_path__ + "img/box3_icon1.96d3e23b.png";